export default {
  name: 'otros',
  props: {
    msg: String
  }
}